import { render } from "./profileDialog.vue?vue&type=template&id=73d940a5&scoped=true"
import script from "./profileDialog.vue?vue&type=script&lang=js"
export * from "./profileDialog.vue?vue&type=script&lang=js"

import "./profileDialog.vue?vue&type=style&index=0&id=73d940a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d940a5"]])

export default __exports__